export default __webpack_public_path__ + "static/media/6.7d94d31f.png";